var _g, _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_319_25803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5375 7.36635C20.7803 5.25036 24.6588 4 28.8235 4C40.3321 4 49.6471 13.3937 49.6471 24.9997C49.6471 36.6058 40.3321 46 28.8235 46C17.315 46 8 36.6058 8 25.0318C8 20.928 9.17637 17.1128 11.1792 13.8747",
    fill: "url(#paint0_linear_319_25803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7249 11.1728C22.2066 9.56704 25.1748 8.61816 28.3621 8.61816C37.1696 8.61816 44.2984 15.7469 44.2984 24.5544C44.2984 33.362 37.1696 40.4911 28.3621 40.4911C19.5546 40.4911 12.4258 33.362 12.4258 24.5788C12.4258 21.4645 13.3261 18.5692 14.8589 16.1119",
    fill: "url(#paint1_linear_319_25803)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6456 16.6472C23.4703 15.1145 25.8061 14.1655 28.3851 14.1655C34.127 14.1655 38.7741 18.8126 38.7741 24.5545C38.7741 30.2965 34.127 34.9436 28.3851 34.9436C22.6431 34.9436 17.9961 30.2965 17.9961 24.5545C17.9961 22.0242 18.8963 19.6885 20.4291 17.888",
    fill: "url(#paint2_linear_319_25803)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5382 20.7102C26.3411 20.1263 27.3143 19.7856 28.3848 19.7856C31.0368 19.7856 33.1779 21.9267 33.1779 24.5787C33.1779 27.2307 31.0368 29.3717 28.3848 29.3717C25.7328 29.3717 23.5918 27.2307 23.5918 24.5787C23.5918 23.6542 23.8595 22.7783 24.3217 22.0483",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2844 12.9004L20.2601 13.4114L20.11 15.3618L20.1385 15.3333L28.6541 23.849C28.9703 24.1653 28.9703 24.6762 28.6541 24.9925C28.3377 25.3088 27.8268 25.3088 27.5105 24.9925L18.9949 16.4769L19.0006 16.4712L16.5132 16.6472C15.8563 16.6959 15.1994 16.4526 14.7127 15.966L9.9197 11.173C9.60344 10.8323 9.79806 10.2484 10.2846 10.2241L12.5418 10.0779L12.0851 9.56712C11.7689 9.25078 11.7689 8.73989 12.0851 8.42355C12.4014 8.10728 12.9124 8.10728 13.2286 8.42355L13.7333 8.98165L13.8855 6.64753C13.9099 6.16094 14.4938 5.94195 14.8344 6.28259L19.6031 11.0999C20.0897 11.5622 20.333 12.2191 20.2844 12.9004Z",
    fill: "url(#paint3_linear_319_25803)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_319_25803",
    x: 0.235294,
    y: 0.117647,
    width: 57.1759,
    height: 57.5294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.88235
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.88235
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_319_25803"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_319_25803",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_319_25803",
    x1: 28.8099,
    y1: 3.02854,
    x2: 28.8099,
    y2: 46.4521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EEADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#3CB5AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_319_25803",
    x1: 28.3517,
    y1: 7.88094,
    x2: 28.3517,
    y2: 40.8342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_319_25803",
    x1: 28.3851,
    y1: 14.1655,
    x2: 28.3851,
    y2: 34.9436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F56565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E53E3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_319_25803",
    x1: 19.3284,
    y1: 6.11768,
    x2: 28.8244,
    y2: 25.1765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#728097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3749"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResult);
export default __webpack_public_path__ + "static/media/result.6f8f85347adb9c5982370b2be73d3c17.svg";
export { ForwardRef as ReactComponent };